module.exports = {
  schema: {
    type: 'Object',
    contents: {
      name: {
        type: 'String',
        name: '姓名',
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/users.js